import I18n from '../../config/i18n';
import MaintenanceIcon from '../icons/maintenance.svg';
import Page from './Page';

export default class MaintenancePage extends Page {
  render() {
    return (
      <div>
        <div className="center px4">
          {
            <MaintenanceIcon
              style={{ width: '20%', height: '20%', paddingTop: '10%' }}
            />
          }
          <div className="px4 h3 brand-color">
            {I18n.t('maintenanceHeader')}
          </div>
          <div className="px4 py1">{I18n.t('maintenanceApology')}</div>
          <div>
            {I18n.t('maintenanceThanks')} {I18n.t('maintenanceSupport')}
          </div>
          <div className="py1">
            <div>
              Americas: +1 (424) 343-2691 | Europe: +44 (1625) 800086 |
              Australia: +61 1800-401191 | Asia: +91 (44) 4348-8850
            </div>
            <div>
              Skype: support@qubewire.com | E-mail: support@qubewire.com
            </div>
          </div>
        </div>
      </div>
    );
  }
}
